<template>
  <ClusterTotal
    v-if="area?.name === 'Cluster' && time?.name === 'Total'"
    :widget="widget"
  />
  <SiteTotal
    v-else-if="area?.name === 'Site' && time?.name === 'Total'"
    :widget="widget"
  />
  <ZoneTotal
    v-else-if="area?.name === 'Zone' && time?.name === 'Total'"
    :widget="widget"
  />
  <UniqueBar
    v-else
    :widget="widget"
    :area="area"
    :time="time"
    :zone="zone"
    :cluster="cluster"
    :day="day"
  />
</template>

<script lang="ts" setup>
import ClusterTotal from './ClusterTotal.vue';
import SiteTotal from './SiteTotal.vue';
import UniqueBar from './UniqueBar.vue';
import ZoneTotal from './ZoneTotal.vue';

import type { WidgetFilter, WidgetSetting, DataUniqueVisitors } from '@/types/Widget';

defineProps<{
  widget: DataUniqueVisitors,
  area?: WidgetFilter,
  time?: WidgetFilter,
  zone?: WidgetSetting,
  day?: WidgetSetting,
  cluster?: WidgetSetting,
}>()
</script>
